import {
  Link,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { formatAddress, formatNumber } from 'common/utils';

import Mana from 'assets/images/png/mana.png';

export default function OrderTable({ data = [] }) {
  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell align="center">
              <Typography fontWeight="bold" variant="h6">
                OWNER
              </Typography>
            </TableCell>
            <TableCell align="center">
              <Typography fontWeight="bold" variant="h6">
                PRICE
              </Typography>
            </TableCell>
            <TableCell align="center">
              <Typography fontWeight="bold" variant="h6">
                STATUS
              </Typography>
            </TableCell>
            <TableCell align="center">
              <Typography fontWeight="bold" variant="h6">
                BUYER
              </Typography>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row, index) => (
            <TableRow key={index}>
              <TableCell align="center">
                <Link
                  underline="none"
                  href={`https://etherscan.io/address/${row.owner}`}
                  target="_blank"
                >
                  <Typography fontWeight="500">
                    {formatAddress(row?.owner || '')}
                  </Typography>
                </Link>
              </TableCell>
              <TableCell
                align="center"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <img style={{ height: 10 }} src={Mana} alt="Mana" />
                <Typography sx={{ fontWeight: 500 }}>
                  {formatNumber(row?.price || '')}
                </Typography>
              </TableCell>
              <TableCell align="center">
                <Typography
                  sx={{ textTransform: 'uppercase', fontWeight: 500 }}
                >
                  {row?.status || ''}
                </Typography>
              </TableCell>
              <TableCell align="center">
                <Link
                  underline="none"
                  href={`https://etherscan.io/address/${row.buyer}`}
                  target="_blank"
                >
                  <Typography sx={{ fontWeight: 500 }}>
                    {formatAddress(row?.buyer)}
                  </Typography>
                </Link>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
